import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson = () => {
  let initData: any = {
    table: "todo_dailyc",
    list_id: "dailyc_month_list",
    x_column_list_arr: [
      // {"key":"row_view_manage","name":"관리","width":"80","is_show":"1"},
      { "key": "a_user_name", "name": "이름", "width": "100", "is_show": "1" },
      { "key": "row_tot", "name": "갯수", "width": "100", "is_show": "1" },
      { "key": "complete_cnt", "name": "완료", "width": "100", "is_show": "1" },
      { "key": "a_star_cnt", "name": "성과별", "width": "100", "is_show": "1" },
      { "key": "a_teacher_star", "name": "추가별", "width": "100", "is_show": "1" },
      { "key": "row_tot_star", "name": "별합계", "width": "100", "is_show": "1" },
    ],
    list_opt_origin: {
      'now_page': 1,
      'num_per_page': 100,
      'order_id': '',
      'order_type': '',
      's_date_type': '',
      's_start_date': '',
      's_end_date': '',
      'sc': {},
      "is_add_idx_info": "1",
    },
  };
  initData.pri_col_arr = ["a_seq"];
  const xColumnArr: any = XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;